"use strict";
import Ashiato from './ashiato';

class Ashiato2 extends Ashiato{
	constructor($con){
		super($con);	
	}
	
	init(){
		this.addAshiato(1,3,'bottom',{left:18,top:0},90);
	}
}

export default Ashiato2;


// WEBPACK FOOTER //
// ./js/parts/ashiato2.js